import { fromJS } from 'immutable';
import {
  MODAL__PUSH,
  MODAL__REMOVE,
  MODAL__HIDE,
  MODAL__SHOW,
  MODAL__SURVEY_PUBLISH,
  SURVEYS__UPDATE_ACTION__REVIEW,
  USER__LOG_OFF,
  EMAIL_CAMPAIGNS__PARTICIPANTS_DOWNLOAD,
} from '../constants';
import { getBeginType } from '../api-client/selectors.api-client';

const defaultState = fromJS({
  stack: [],
});

function push(state, modalId) {
  const nextStack = state.get('stack').push(modalId);
  return state.set('stack', nextStack);
}
function pop(state, modalId) {
  const nextStack = state.get('stack').filter((item) => item !== modalId);
  return state.set('stack', nextStack);
}

export default function (state = defaultState, { type, payload, ...action }) {
  switch (type) {
    case `${EMAIL_CAMPAIGNS__PARTICIPANTS_DOWNLOAD}___ERROR`: {
      return state.set('stack', fromJS([]));
    }
    case MODAL__PUSH:
      return push(state, payload);
    case MODAL__REMOVE:
      return pop(state, payload);
    case MODAL__SHOW:
      return state.merge(payload);
    case MODAL__HIDE:
      return state.delete('modalName').delete('surveyId');
    case getBeginType(SURVEYS__UPDATE_ACTION__REVIEW):
      return state.merge({ modalName: MODAL__SURVEY_PUBLISH, surveyId: action.data.id });
    case USER__LOG_OFF:
      return defaultState;
    default:
      return state;
  }
}
